import { useRef, useState } from "react";
import { UploadCloud, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "@/i18n";
import { api, fileUrl } from "@/lib/api";

export default function UploadBox({ fileId, onUploaded, testid = "product-upload" }) {
  const { t, errMsg } = useI18n();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [drag, setDrag] = useState(false);

  const send = async (file) => {
    if (!file) return;
    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) return toast.error(t("errors.UNSUPPORTED_FORMAT"));
    if (file.size > 15 * 1024 * 1024) return toast.error(t("errors.FILE_TOO_LARGE"));
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/uploads", fd);
      onUploaded(data.file_id);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <p className="text-sm font-medium mb-2">{t("tool.upload")}</p>
      <button type="button" onClick={() => ref.current?.click()} data-testid={testid}
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }} onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); send(e.dataTransfer.files[0]); }}
        className={`w-full rounded-xl border-2 border-dashed transition-colors overflow-hidden ${drag ? "border-emerald-500 bg-emerald-500/5" : "border-[var(--line)] hover:border-neutral-500"}`}>
        {fileId ? (
          <div className="relative bg-white h-48">
            <img src={fileUrl(fileId)} alt="" className="w-full h-full object-contain" data-testid="upload-preview" />
            <span className="absolute bottom-2 right-2 text-xs bg-black/75 text-white rounded-full px-2.5 py-1">{t("tool.change")}</span>
          </div>
        ) : (
          <div className="h-40 flex flex-col items-center justify-center gap-2 text-neutral-400">
            {busy ? <Loader2 className="animate-spin" /> : <UploadCloud />}
            <span className="text-sm">{busy ? t("tool.uploading") : t("tool.dropHere")}</span>
            <span className="text-[11px] text-neutral-500">{t("tool.uploadHint", { mb: 15 })}</span>
          </div>
        )}
      </button>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" hidden onChange={(e) => { send(e.target.files[0]); e.target.value = ""; }} data-testid={`${testid}-input`} />
    </div>
  );
}
